import { action, makeObservable, observable } from "mobx"

class NavigationStateStore {
  @observable accessor isNavigatingDueToAuthError: boolean = false

  constructor() {
    makeObservable(this)
  }

  @action
  setNavigatingDueToAuthError(isNavigating: boolean): void {
    this.isNavigatingDueToAuthError = isNavigating
  }
}

export const navigationStateStore = new NavigationStateStore()
